import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// BARNES Design System drawer (dist/css/drawer.css), ADR 0003 D1: 400px panel, square, overlay
// shadow; header title 22px light; footer with a top border on surface-alt.
export const Drawer: ComponentMultiStyleConfig = {
  parts: ["overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer"],
  baseStyle: {
    overlay: {
      bg: "drawerOverlay",
    },
    dialog: {
      bg: "surface",
      color: "text",
      borderRadius: "none",
      borderLeft: "1px solid",
      borderLeftColor: "line",
      boxShadow: "overlay",
    },
    header: {
      px: 6,
      pt: 6,
      pb: 5,
      pr: 16,
      fontSize: "xl",
      fontWeight: "light",
      lineHeight: "snug",
      color: "text",
    },
    closeButton: {
      top: 5,
      insetEnd: 5,
      w: "40px",
      h: "40px",
      color: "textMuted",
      _hover: {
        color: "accent",
        bg: "transparent",
      },
    },
    body: {
      px: 6,
      pt: 1,
      pb: 6,
    },
    footer: {
      px: 6,
      pt: 5,
      pb: 6,
      gap: 3,
      bg: "surfaceAlt",
      borderTop: "1px solid",
      borderTopColor: "line",
    },
  },
  // Width follows the content (decided in review, ADR 0003): at least the design system's 400px,
  // wider when a page's filters need it, capped so the list always stays visible.
  sizes: {
    md: {
      dialog: {
        w: "auto",
        minW: "min(400px, 92vw)",
        maxW: "min(960px, 92vw)",
      },
    },
  },
  defaultProps: {
    size: "md",
  },
}
